import axios from './axios';

let baseUrl = '';
const authentication = {};

const init = function(url) {
    // use init to set the baseUrl
    baseUrl = url;

    return authentication;
};

authentication.registration = function (data) {
    return new Promise((resolve, reject) => {
        axios.post(baseUrl + 'registration', data).then(function (res) {
            resolve(res.data);
        }).catch(function (error) {
            reject(error.response);
        });
    });
};

authentication.login = function (data) {
    return new Promise((resolve, reject) => {
        axios.post(baseUrl + 'login', data).then(function (res) {
            resolve(res.data);
        }).catch(function (error) {
            reject(error.response);
        });
    });
};

authentication.logout = function (data) {
    return new Promise((resolve, reject) => {
        axios.post(baseUrl + 'logout', data).then(function (res) {
            resolve(res.data);
        }).catch(function (error) {
            reject(error.response);
        });
    });
};

authentication.auth = function () {
    return new Promise((resolve, reject) => {
        axios.post(baseUrl + 'auth').then(function (res) {
            resolve(res.data);
        }).catch(function (error) {
            reject(error.response);
        });
    });
};

authentication.forgotPassword = function (data) {
    return new Promise((resolve, reject) => {
        axios.post(baseUrl + 'forgotPassword', data).then(function (res) {
            resolve(res.data);
        }).catch(function (error) {
            reject(error.response);
        });
    });
};

authentication.resetPassword = function (data) {
    return new Promise((resolve, reject) => {
        axios.post(baseUrl + 'resetPassword', data).then(function (res) {
            resolve(res.data);
        }).catch(function (error) {
            reject(error.response);
        });
    });
};

authentication.validateHandoff = function (token) {
    return new Promise((resolve, reject) => {
        axios.get(baseUrl + 'validate-handoff', {
            params: { token }
        }).then(function (res) {
            resolve(res.data);
        }).catch(function (error) {
            reject(error);
        });
    });
};

export default init;